import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '@app/directives/base-component';

@Component({
    selector: 'app-sepa-account',
    templateUrl: './sepa-account.component.html',
    styleUrls: ['./sepa-account.component.scss'],
    standalone: false
})

export class SEPAAccountComponent extends BaseComponent implements OnInit {
  @Input() sepa: any;
  @Input() defaultPaymentId: string;
  @Output() onUpdate: EventEmitter<any> = new EventEmitter();

  constructor() { super(); }

  ngOnInit(){
    // console.log(this.sepa, this.defaultPaymentId)
  }
  onClickList(sepa){
    this.onUpdate.next(sepa)
  }
}